<div class="dev-menu">
  <div class="dev-menu__item" *ngFor="let menuItem of menuItems">
    <a [routerLink]="menuItem" routerLinkActive="active">{{ menuItem }}</a>
  </div>
</div>
